<header>
  <div nz-row>
    <div nz-col nzSpan="24">
      <nav class="navbars" style="display: block">
        <ul class="nav-links" style="font-size: small">
          <li>
            <a class="head" href="https://inside.chevron.com/">Inside Home</a>
          </li>
          <span style="color: grey">|</span>
          <li>
            <a class="head" href="https://m365.cloud.microsoft/search?auth=2"
              >Find & Search</a
            >
          </li>
          <span style="color: grey">|</span>
          <li>
            <a class="head" href="http://whitepages.chevron.com/"
              >People Finder</a
            >
          </li>
        </ul>
      </nav>
    </div>
  </div>
  <div nz-row>
    <div nz-col nzSpan="12">
      <img
        (click)="navigateToHome()"
        src="./../../../assets/P_A_site_name.jpg"
        alt=""
        style="border-width: 0px; margin-top: 20px; cursor: pointer"
      />
    </div>
    <div nz-col nzSpan="12">
      <img
        src="./../../assets/img_hallmark_2.gif"
        alt="Chevron Logo"
        class="logo"
        style="float: right"
      />
    </div>
  </div>
</header>
